import { Component } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-about',
  imports: [],
  templateUrl: './about.html',
  styleUrl: './about.css',
})
export class About {

  public goToGame(){

    const room_id = this.activated_route.snapshot.queryParamMap.get('room');

    room_id
      ? this.router.navigate([`/mind-link/waiting-room/${room_id}`])
      : this.router.navigate(['/mind-link'])

  }

  constructor(
    private router: Router,
    private activated_route: ActivatedRoute
  ){}

}
